import { LicenseInfo } from '@mui/x-license-pro';

export const muiPro = () => LicenseInfo.setLicenseKey('3ef5d6119b9d5d6d80b8e41fbd45c986Tz0xMTYzNTksRT0xNzg2MzE5OTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=');
